export default "__VITE_ASSET__4gK_nEsQ__"